import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API } from '../context/AuthContext';
import { colors, fonts } from '../brand';

export default function ActivateMembership() {
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    const freeToken = new URLSearchParams(location.search).get('free_token');
    if (!freeToken) {
      setStatus('error');
      setMessage('Invalid activation link.');
      return;
    }

    axios.post(`${API}/api/auth/activate-membership`, { free_token: freeToken })
      .then(res => {
        // Log the user in automatically
        localStorage.setItem('token', res.data.token);
        setStatus('success');
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'This link is invalid or has expired.');
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={styles.page}>
      <div style={styles.logoArea} onClick={() => navigate('/')}>
        <img src="/logo.svg" alt="Elephants Answering" style={styles.logoIcon} />
        <div>
          <div style={styles.logoText}>Elephants Answering, PBC</div>
          <div style={styles.logoSub}>Divorce Support & Refuge</div>
        </div>
      </div>

      <div style={styles.card}>
        {status === 'loading' && (
          <p style={styles.body}>Activating your membership...</p>
        )}
        {status === 'success' && (
          <>
            <h2 style={styles.title}>You're in.</h2>
            <p style={styles.body}>Your Free for Early Members access has been activated. Welcome to the community.</p>
            <button style={styles.btn} onClick={() => navigate('/dashboard')}>
              Go to My Account
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <h2 style={styles.title}>Something went wrong.</h2>
            <p style={styles.body}>{message}</p>
            <button style={styles.btn} onClick={() => navigate('/login')}>
              Sign In
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: colors.cream, padding: '40px 20px' },
  logoArea: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '40px', cursor: 'pointer' },
  logoIcon: { height: '140px', width: 'auto' },
  logoText: { fontFamily: fonts.heading, color: colors.navy, fontSize: '17px', fontWeight: '600', letterSpacing: '0.5px' },
  logoSub: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '11px', letterSpacing: '0.3px', marginTop: '3px' },
  card: { backgroundColor: colors.white, border: `1px solid ${colors.peach}`, padding: '48px 40px', maxWidth: '420px', width: '100%', textAlign: 'center' },
  title: { fontFamily: fonts.heading, color: colors.navy, fontSize: '24px', marginBottom: '16px', fontWeight: '600' },
  body: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '14px', lineHeight: '1.8', marginBottom: '24px' },
  btn: { backgroundColor: colors.rose, color: colors.white, border: 'none', padding: '14px 32px', fontSize: '14px', fontFamily: fonts.body, fontWeight: '600', cursor: 'pointer', letterSpacing: '0.5px' },
};
